import { INFO360_THEMES } from '../../theme/theme.types';
import { AppBranding } from '../../../../types/appBranding';
import { useWeaveThemeContext } from '../../theme/WeaveContext';
import React from 'react';

export default function useAppBranding(branding?: AppBranding): AppBranding {
	const { theme, isWeaveTheme } = useWeaveThemeContext();
	const _branding = React.useMemo(() => {
		if (branding) return branding;
		if (
			isWeaveTheme &&
			(theme === INFO360_THEMES.Light ||
				theme === INFO360_THEMES.LightHighDensity)
		) {
			return 'info360Light';
		}
		return 'info360';
	}, [branding, theme, isWeaveTheme]);
	return _branding;
}
